import http from '@/assets/common/http';
// 获取购物车是否有商品
export function getShopCarFun(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 插入领料记录
export function addRecord(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取购物车内容
export function shopCarDetail(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 加购物车
export function addShopCarFun(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除购物车中某个商品
export function deleteShopDetail(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改某个商品
export function editShopCarFun(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 清空商品
export function clearShopCarFun(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 下单
export function createOrder(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取领料单
export function getDocFun(data) {
  const params = {
    SERVICE_ID: '10056',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 领料单详情
export function getDocDetailFun(data) {
  const params = {
    SERVICE_ID: '10056',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 切换日期
export function changeFun(data) {
  const params = {
    SERVICE_ID: '10055',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取单品对应单位
export function finishFun(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 提交生产
export function submitFinish(data) {
  const params = {
    SERVICE_ID: '10056',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 生产完成
export function enterFun(data) {
  const params = {
    SERVICE_ID: '10057',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查看生产
export function openResultFun(data) {
  const params = {
    SERVICE_ID: '10057',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改生产
export function editFun(data) {
  const params = {
    SERVICE_ID: '10057',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 确认入库
export function enterWareFun(data) {
  const params = {
    SERVICE_ID: '10057',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 生产领料单退库
export function returnWareFun(data) {
  const params = {
    SERVICE_ID: '10056',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出
export function exportPickingDocFun(data) {
  const params = {
    SERVICE_ID: '10056',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/proDepartment.js